import { Link } from "react-router-dom";
import { ValueSetModel } from "../models/ValueSetModel";
import {
  Container,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface Props {
  valueSets: ValueSetModel[];
}

const useStyles = makeStyles({
  link: {
    display: "block",
    textDecoration: "none",
  },
});

const ValueSetTable: React.FC<Props> = ({ valueSets }) => {
  const classes = useStyles();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          // height: 240,
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: 700,
                  },
                }}
              >
                <TableCell align="left">Name</TableCell>
                <TableCell align="left">Date</TableCell>
                <TableCell align="left">Version</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Url</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {valueSets.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left"><Link className={classes.link} to={row.id}>{row.name}</Link></TableCell>
                  <TableCell align="left">{row.date}</TableCell>
                  <TableCell align="left">{row.version}</TableCell>
                  <TableCell align="left">{row.status}</TableCell>
                  <TableCell align="left">{row.url}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
};

export default ValueSetTable;
